export function TrackService(rest) {
  return {
    // Start a new tracking session

    verify: (token) => rest.post('/api/v1/verify', token),

    startTrack: (incidentId, organizationId) =>
      rest.post('/api/v1/tracks/start', {
        incident_id: incidentId,
        organization_id: organizationId
      }),

    // Pause tracking
    pauseTrack: (id) => rest.put(`/api/v1/tracks/${id}/pause`),

    // Resume tracking
    resumeTrack: (id) => rest.put(`/api/v1/tracks/${id}/resume`),

    // Resume tracking
    cancelTrack: (id) => rest.put(`/api/v1/tracks/${id}/cancel`),

    // End tracking
    endTrack: (id, name) => rest.put(`/api/v1/tracks/${id}/end`, { name }),

    // Update track name
    updateTrackName: (id, name) =>
      rest.put(`/api/v1/tracks/${id}/name`, { name }),

    // Add GPS points
    addPoints: (id, points) =>
      rest.post(`/api/v1/tracks/${id}/points`, { points }),

    // Sync offline points
    syncPoints: (id, points) =>
      rest.post(`/api/v1/tracks/${id}/sync`, { points }),

    // Get all tracks for incident
    getTracksByIncident: (incidentId) =>
      rest.get(`/api/v1/tracks/incident/${incidentId}`),

    // Get one track with points
    getTrack: (id) => rest.get(`/api/v1/tracks/${id}`),

    // Delete only ended tracks
    deleteTrack: (id) => rest.delete(`/api/v1/tracks/${id}`),

    // Export KML
    exportKml: (id) =>
      rest.raw.get(`/api/v1/tracks/${id}/export.kml`, {
        responseType: 'blob'
      }),

    // Export GPX
    exportGpx: (id) =>
      rest.raw.get(`/api/v1/tracks/${id}/export.gpx`, {
        responseType: 'blob'
      }),

    // ===== PIN RELATED APIs =====

    // Create a new pin
    createPin: (pinData) => rest.post('/api/v1/pins', pinData),

    // Update a pin
    updatePin: (id, pinData) => rest.put(`/api/v1/pins/${id}`, pinData),

    // Delete a pin
    deletePin: (id) => rest.delete(`/api/v1/pins/${id}`),

    // Get all pins for an incident
    getPinsByIncident: (incidentId) => rest.get(`/api/v1/pins/${incidentId}`),

    //update location
    updateLocation: (data) => rest.post(`/api/v1/user-locations/add`, data),

    // get users location by ids
    getUsersLocationByIds: (userIds) =>
      rest.post('/api/v1/user-locations/users', {
        ids: userIds
      }),

    // Get available colors for tracks
    getTrackColors: () => 
      rest.get('/api/v1/tracks/get-colors'),

    // Update track color
    updateTrackColor: (id, color) => 
      rest.put(`/api/v1/tracks/${id}/color`, { color }),
  }
}
